import axios from '@/plugins/http/axios.js';
import config from "@/views/categories_marketplace/config/category_marketplace_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);


export const service = {
    getCategoriesMarketplace : (idGroup,idEmpresa, idUsuario, idModo) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/categoria/modo/${idModo}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getCategoriesMarketplacedelete : (idGroup,idEmpresa, idUsuario, idCategory) => {
        return axios({
            method: 'delete',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/categoria/delete/${idCategory}`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    }
}
